<template>
  <div
    :class="{
      'ui-chevron': true,
      'ui-chevron--open': isOpen,
    }"
  >
    <ui-icon
      v-if="isOpen"
      class="ui-chevron__icon ui-chevron__icon--up"
      icon="far fa-angle-up"
      :color="color"
      :size="size"
      :disabled="disabled"
    />

    <ui-icon
      v-if="!isOpen"
      class="ui-chevron__icon ui-chevron__icon--down"
      icon="far fa-angle-down"
      :color="color"
      :size="size"
      :disabled="disabled"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    open?: boolean | string;
    disabled?: boolean;
    color?: string;
    size?: string;
  }>(),
  {
    open: false,
    disabled: false,
    size: '13',
  },
);

const isOpen = computed(() => {
  if (props.open === true || props.open === 'true') {
    return true;
  }
  if (props.open === false || props.open === 'false') {
    return false;
  }
  return Boolean(props.open);
});
</script>

<style lang="scss">
.ui-chevron {
  display: flex;
  align-items: center;

  .ui-chevron__icon.ui-icon {
    font-size: 13px;
    line-height: 1.33 !important;
  }
}
</style>
